// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"RuleItem_wrapper__12aNU","label":"RuleItem_label__8zOfK"};